export const environment = {
  production: true,
  redirectSignIn: 'https://admin.dev.saas-upgrade.sailpointtechnologies.com',
  redirectSignOut: 'https://admin.dev.saas-upgrade.sailpointtechnologies.com',
  requestUrl: 'https://api.dev.saas-upgrade.sailpointtechnologies.com/',
  assessmentUrl: 'https://api.assessor.dev.saas-upgrade.sailpointtechnologies.com',
  defaultQuestionnaireId: 'identityiq',
  client_id: '1690ghpofsi11tvgp5p0bfj44o',
  customerLoginLink: 'https://dev.saas-upgrade.sailpointtechnologies.com/?access-token=',
  // customerLoginLink: 'https://saas-upgrade.sailpointtechnologies.com?access-token='
  rumAppMonitorId: '8406e4c8-5c85-4fa8-91fe-590617d48303',
  rumUrl: 'https://api.dev.saas-upgrade.sailpointtechnologies.com/auth/rum-token',
  userPoolId: 'us-east-1_ObVviVEAC',
  identityPoolId: 'us-east-1:6044cd88-c57a-4d0d-9f7a-8aefeb2b326f'
};
